export const reservationDrawer = {
  title: "Buchungsdetails",
  openFullPage: "Auf ganzer Seite öffnen",
  close: "Schließen",
};
